import { apiRequest } from '../core';


export function getPracticeCasesByFilter(categories, tags, sort, take, skip) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Contest/GetPracticeCasesByFilter`);

  const params = {};
  if (categories) {
    params.categories = categories;
  }
  if (tags) {
    params.tags = tags;
  }
  if (take) {
    params.take = take;
  }
  if (skip) {
    params.skip = skip;
  }
  if (sort) {
    params.sort = sort;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return apiRequest(url);
}

export function getPracticeCaseByAlias(alias) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Contest/GetPracticeCaseByAlias`);

  const params = {};
  if (alias) {
    params.alias = alias;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return apiRequest(url);
}

export function getRelatedPracticeCase(practiceCaseId) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Contest/GetRelatedPracticeCase`);

  const params = {};
  if (practiceCaseId) {
    params.practiceCaseId = practiceCaseId;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return apiRequest(url);
}

export function getContestCategoties() {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Contest/GetContestCategoties`);
  return apiRequest(url);
}

export function getContestTags() {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Contest/GetContestTags`);
  return apiRequest(url);
}

export function getVimeoPreview(vimeoId) {
    const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Contest/GetVimeoPreview/`);
  
    if (vimeoId) {
        url.searchParams.append("vimeoId", vimeoId);
    }
    return apiRequest(url);
}